import { useState, useEffect } from 'react';
import apiClient from '../apiClient';

export const useSession = (idFromURL, completedParam, type = 'session') => {
  const [sessionId, setSessionId] = useState(idFromURL);
  const [isCompleted, setIsCompleted] = useState(completedParam);

  const createSession = async (templateId, endpoint = '/recorder/sessions/start', whisperBackend = null, clientSessionId = null) => {
    try {
      const payload = type === 'session'
        ? {
            template_id: templateId,
            ...(whisperBackend && { whisper_backend: whisperBackend }),
            // Lokal-först: länka server-sessionen till klientens id så att chunk-
            // uploads hittar samma session (annars skapas en dubblett).
            ...(clientSessionId && { client_session_id: clientSessionId }),
          }
        : {};
      
      const resp = await apiClient.post(endpoint, payload);
      const id = type === 'session' ? resp.data.session_id : resp.data.meeting_id;
      setSessionId(id);
      console.log(`Ny ${type} skapad:`, id);
      return id;
    } catch (err) {
      console.error(`Kunde inte starta ${type}:`, err);
      throw err;
    }
  };

  const updateSessionStatus = async (status, elapsedTime = null) => {
    if (!sessionId) return;
    
    try {
      let endpoint = type === 'session' 
        ? `/recorder/sessions/${sessionId}/${status}`
        : `/meetings/${sessionId}/${status}`;

      const payload = {};
      if (elapsedTime && type === 'session') {
        payload.elapsed_time = elapsedTime; // Send in milliseconds as backend expects
      }
      
      await apiClient.post(endpoint, payload);
    } catch (err) {
      console.error(`Fel vid ${status} ${type}:`, err);
      throw err;
    }
  };

  const fetchSessionData = async (id, onDataLoaded) => {
    try {
      let endpoint = type === 'session' 
        ? `/recorder/sessions/${id}`
        : `/meetings/${id}`;
        
      const resp = await apiClient.get(endpoint);
      const data = resp.data;
      
      if (onDataLoaded) {
        onDataLoaded(data);
      }
      
      return data;
    } catch (err) {
      console.error(`Kunde inte hämta ${type}:`, err);
      throw err;
    }
  };

  return {
    sessionId,
    setSessionId,
    isCompleted,
    setIsCompleted,
    createSession,
    updateSessionStatus,
    fetchSessionData
  };
};